module.exports = __webpack_public_path__ + "mf.svg?4a15f25c47f2e3e5e6e06f6cd1a7a01c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mf.svg
// module id = 1067
// module chunks = 27